export default __webpack_public_path__ + "static/jennifer-bitmoji-0b6d34d652ad3d2b998b5f78e9db7cbb.png";